var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0879 5.42529L16.5715 13.7795C16.4395 15.914 16.3736 16.9812 15.8386 17.7485C15.574 18.1279 15.2335 18.448 14.8385 18.6886C14.0396 19.1753 12.9704 19.1753 10.8318 19.1753C8.69049 19.1753 7.61981 19.1753 6.82043 18.6877C6.42522 18.4467 6.08456 18.126 5.82012 17.746C5.28529 16.9775 5.22077 15.9087 5.09173 13.7713L4.58789 5.42529",
    stroke: "#F80B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33789 5.42521H18.3379M14.2176 5.42521L13.6488 4.25165C13.2709 3.4721 13.0819 3.08231 12.756 2.83922C12.6837 2.78529 12.6071 2.73733 12.5271 2.69579C12.1661 2.50854 11.733 2.50854 10.8666 2.50854C9.97856 2.50854 9.53456 2.50854 9.16762 2.70364C9.08631 2.74689 9.00871 2.7968 8.93563 2.85285C8.60592 3.1058 8.42175 3.50984 8.0534 4.31793L7.54866 5.42521",
    stroke: "#F80B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75464 14.5919V9.59192",
    stroke: "#F80B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9211 14.5919V9.59192",
    stroke: "#F80B0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0e27f31e9469cd33788b5571aa8402ae.svg";
export { ForwardRef as ReactComponent };